import request from "../common/request";
import store from "@/store";
import native from "@/common/Native";
import {
  ILiveDetails,
  ILiveText,
  INewsReleaseDetails,
  IIncreaseViewCount,
  IGetBusinessDetail,
  IGetShareInfo,
  IComment,
  IHot,
  IShareConfig,
  IResponse,
  INewsDetail,
  IWXResponse,
  appInfoRes,
  IPosterInfo,
  // IPosterImageStr,
  IPosterImageStrResonse,
  IPosterInfoResponse,
  ICommonResponse,
  IAppConfigViewcount,
  IWzInfoResponse,
  IMediaDetailResponse,
  IMediaListResponse
} from "./types.d";
import { IMultiple, IMultipleMore } from "./types.d";
import Axios from "axios";
/**
 * 网络请求类 接口调用
 */
class RequestIndex {
  get token() {
    return store.state.token;
  }
  get appId() {
    return store.state.appId;
  }
  get sessionId() {
    return store.state.sessionId;
  }

  /**
   * 多图新闻详情 /info/v2/detail.html
   * @param id 新闻id
   */
  async getList(id: string): Promise<IMultiple | any> {
    let res;
    try {
      const res1 = await request.get(
        process.env.VUE_APP_BASE_JSON + `/app/news/info_v2_Detail/${id}.json`
      );
      res = {
        data: res1,
        code: 0
      };
    } catch (error) {
      res = await request.get("/info/v2/detail.html", {
        params: { id: id }
      });
    }
    return res;
  }

  /**
   * 多图推荐 /getImagAandVideoCorrelation.html
   * @param id 新闻id
   */
  public getImgMore(id: string): Promise<IMultipleMore> {
    return request.post(
      process.env.VUE_APP_BASEGATE_API + "/getImagAndVideoCorrelation",
      {
        appId: 1,
        id: id
      }
    );
  }
  /**
   * 直播新闻发布类详情
   * @param icid infoClassifyid
   */
  liveDetail(icid: string): Promise<ILiveDetails> {
    return request.get("/live_publish/detail.html", {
      params: {
        token: this.token,
        icid: icid
      }
    });
  }

  /**
   * 直播文字
   * @param infoId informationId
   * @param lastSort 分页，最后条数据的sort_no
   * @param lastTime 分页，最后条数据的online_time
   * @param lastId 分页，最后条数据的id
   */
  liveText(
    infoId: number,
    lastSort: number | undefined,
    lastTime: string | undefined,
    lastId: number | undefined
  ): Promise<ILiveText> {
    return request.get("/live_publish/text.html", {
      params: {
        token: this.token,
        infoId: infoId,
        ls: lastSort,
        lo: lastTime,
        li: lastId
      }
    });
  }

  /**
   * 直播现场详情
   * @param id id
   */
  detail(id: string): Promise<INewsReleaseDetails> {
    return request.get("/live_publish/image/detail.html", {
      params: {
        id: id,
        token: this.token
      }
    });
  }

  /**
   * 增加浏览量
   * @param sourceId 新闻ID
   * @param sourceType informationId
   */
  increaseViewCount(
    sourceId: string,
    sourceType: string
  ): Promise<IIncreaseViewCount> {
    return request.post("/increaseViewCount.html", {
      appId: this.appId,
      sessionId: "",
      token: this.token,
      sourceId: sourceId,
      sourceType: sourceType
    });
  }

  /**
   * 获取业务详情信息
   * @param sourceId 新闻ID
   * @param sourceType informationId
   */
  async getBusinessDetail(sourceId: string, sourceType: string): Promise<any> {
    let res;
    try {
      const res1 = await request.get(
        process.env.VUE_APP_BASE_JSON +
          `/app/news/getBusinessDetail/${this.appId}/${sourceType}/${sourceId}.json`
      );
      res = {
        data: res1
      };
    } catch (error) {
      res = await request.post(
        process.env.VUE_APP_BASEGATE_API + "/getBusinessDetail",
        {
          appId: this.appId,
          sessionId: "",
          token: this.token,
          sourceId: sourceId,
          sourceType: sourceType
        }
      );
    }
    return res;
  }

  /**
   * 获取唤醒app信息接口
   */
  getShareInfo(): Promise<IGetShareInfo> {
    try {
      return request.get(
        `https://h5cloud.cqliving.com/statics/h5/res/share/${this.appId}.json?t=` +
          new Date().getFullYear() +
          (new Date().getMonth() + 1) +
          new Date().getDate() +
          new Date().getHours()
      );
    } catch (error) {
      return request.post("/getShareInfo.html", {
        appId: this.appId
      });
    }
  }
  //新闻业务详情
  async getBussinessDetail(
    appId: string,
    sessionId: string,
    sourceId: string,
    sourceType: string | number,
    token: string
  ) {
    let res;
    try {
      const res1 = await request.get(
        process.env.VUE_APP_BASE_JSON +
          `/app/news/getBusinessDetail/${appId}/${sourceType}/${sourceId}.json`
      );
      res = {
        data: res1,
        code: 0
      };
    } catch (error) {
      res = await request.post(
        process.env.VUE_APP_BASEGATE_API + "/getBusinessDetail",
        {
          appId,
          sessionId,
          sourceId,
          sourceType,
          token
        }
      );
    }
    return res;
  }
  /**
   * 评论列表
   */
  getCommentList(
    appId: string,
    sessionId: string,
    sourceId: string,
    sourceType: string | number,
    token?: string | number,
    time?: string | number
  ): Promise<IComment> {
    return request.post(process.env.VUE_APP_BASEGATE_API + "/comments", {
      appId,
      sessionId,
      sourceId,
      sourceType,
      token,
      time
    });
  }
  /** 评论列表 分页 */
  getCommentListPage(
    appId: string,
    sessionId: string,
    sourceId: string,
    sourceType: string | number,
    lastCreateTime: string,
    lastReplyId: number | undefined,
    token?: string | number
  ): Promise<IComment> {
    return request.post(process.env.VUE_APP_BASEGATE_API + "/comments", {
      appId,
      sessionId,
      sourceId,
      sourceType,
      lastCreateTime,
      lastReplyId,
      token
    });
  }
  /**
   * 获取热点新闻
   */
  async getHotList(id: string, appId: string): Promise<any> {
    let res;
    try {
      const res1 = await request.get(
        process.env.VUE_APP_BASE_JSON +
          `/app/news/getCorrelation/${appId}/0/${id}.json`
      );
      res = {
        code: 0,
        data: res1
      };
    } catch (error) {
      res = await request.post(
        process.env.VUE_APP_BASEGATE_API + "/getCorrelation",
        {
          id,
          appId
        }
      );
    }
    return res;
  }
  /**
   * 获取热点新闻-九龙坡专用
   */
  getHotListJLP(id: string, appId: string): Promise<IHot> {
    return request.post(
      process.env.VUE_APP_BASEGATE_API + "/jiulongpo/getJlpCorrelation",
      {
        id,
        appId
      }
    );
  }
  /** 点赞 */
  doPraise(
    id: string,
    appId: string,
    sessionId: string,
    sourceId: string,
    sourceType: string | number,
    v: string,
    type: string | number,
    token?: string | number,
    time?: string | number
  ): Promise<IResponse> {
    return request.post("/doPraise.html", {
      id,
      appId,
      sessionId,
      sourceId,
      sourceType,
      v,
      type,
      token,
      time
    });
  }
  /** 获取分享信息 */
  getShareInfoMethod(appId: string): Promise<IShareConfig> {
    // return request.post("/getShareInfo.html", {
    //   appId
    // });
    try {
      return request.get(
        `https://h5cloud.cqliving.com/statics/h5/res/share/${appId}.json?t=` +
          new Date().getFullYear() +
          (new Date().getMonth() + 1) +
          new Date().getDate() +
          new Date().getHours()
      );
    } catch (error) {
      return request.post("/getShareInfo.html", {
        appId
      });
    }
  }
  /** 新闻详情 */
  /**
   * 获取新闻详情
   * @param infoClassifyId 新闻的infoClassifyId
   */
  async getNewsDetails(infoClassifyId: string): Promise<INewsDetail | any> {
    // return request.post("/infoDetailNew.html", { infoClassifyId });
    let res;
    try {
      const res1 = await request.get(
        process.env.VUE_APP_BASE_JSON +
          `/app/news/infoDetailNew/${infoClassifyId}.json`
      );
      res = {
        code: 0,
        data: res1
      };
    } catch (error) {
      res = await request.post("/infoDetailNew.html", {
        infoClassifyId
      });
    }
    return res;
  }

  /**
   * 获取公共浏览量，点赞量接口  主要功能：在非客户端增加浏览量
   */
  getCount(appId: string, infoClassifyId: string | number): Promise<any> {
    return request.post("/getAndIncrCount.html", {
      appId,
      infoClassifyId
    });
  }

  /**
   * 获取视频详情
   * @param appId
   * @param infoClassifyId
   */
  getInfoVideoDetails(appId: string, id: string): Promise<INewsDetail> {
    return request.post("/info/getVideoDetail.html", {
      appId,
      id,
      v: 1
    });
  }

  /**新闻分享点赞接口 */
  getpraiseShare(
    appId: string,
    id: string,
    sourceType: string
  ): Promise<IWXResponse> {
    return request.post("/doPraiseShare.html", {
      appId: appId,
      title: "",
      version: "v",
      type: "0", //0点赞1评论(暂不支持评论)
      sourceId: id,
      sourceType: sourceType //短视频41
    });
  }

  /**
   *
   * @param appId 是否点赞
   * @param sessionId
   * @param token
   * @param type
   * @param sourceId
   * @param sourceType
   */
  isPraised(
    appId: string,
    sessionId: string,
    token: string,
    type: string,
    sourceId: string,
    sourceType: string
  ): Promise<IResponse> {
    return request.post("/isPraised.html", {
      appId,
      sessionId,
      token,
      type,
      sourceId,
      sourceType
    });
  }
  /**获取app信息 */
  getAppInfoList(): Promise<any> {
    try {
      return request.get(
        "https://h5cloud.cqliving.com/statics/h5/res/getAppInfoList.json?t=" +
          new Date().getFullYear() +
          (new Date().getMonth() + 1) +
          new Date().getDate() +
          new Date().getHours()
      );
    } catch (error) {
      return request.post(`/getAppInfoList.html`, {});
    }
  }

  /**
   * 海报分享
   * @param infoClassifyId  新闻id
   * @returns
   */
  getPosterShareData(params: { infoClassifyId: string }): Promise<any> {
    return request.post("getPosterShareData.html", {
      infoClassifyId: params.infoClassifyId
    });
  }
  getPosterInfo(params: {
    sourceId: string;
    token?: string;
  }): Promise<IPosterInfoResponse> {
    return request.post(process.env.VUE_APP_BASEGATE_API + `/getPosterInfo`, {
      sourceId: params.sourceId,
      token: params.token
    });
  }

  createPoster(params: {
    postUrl: string;
    gray: string;
    title: string;
    detailUrl: string;
    loginStatus: string;
    username: string;
    onlineTime: string;
    appId: string;
  }): Promise<IPosterImageStrResonse> {
    let createUrl = "";
    if (
      process.env.VUE_APP_ENV == "development" ||
      process.env.VUE_APP_ENV == "testing"
    ) {
      // shareHost = "http://10.2.14.204:8080/";
      createUrl =
        "https://gatewayapitest.cqliving.com/cqliving-boot-zwy-poster-server/post";
    } else if (process.env.VUE_APP_ENV == "pre-release") {
      createUrl =
        "https://gatewayapitest.cqliving.com/cqliving-boot-zwy-poster-server/post";
    } else {
      createUrl =
        "https://gatewayapi.cqliving.com/cqliving-boot-zwy-poster-server/post";
    }

    return request.post(createUrl, {
      postUrl: params.postUrl,
      gray: params.gray,
      title: params.title,
      detailUrl: params.detailUrl,
      loginStatus: params.loginStatus,
      username: params.username,
      onlineTime: params.onlineTime,
      appId: params.appId
    });
  }

  /**
   * 获取app是否显示浏览量
   */
  getAppConfigViewcount(params: {
    appId: string;
  }): Promise<ICommonResponse<IAppConfigViewcount>> {
    try {
      return request.get(
        `https://h5cloud.cqliving.com/statics/h5/res/appconfig/${params.appId}.json?t=` +
          new Date().getFullYear() +
          (new Date().getMonth() + 1) +
          new Date().getDate() +
          new Date().getHours()
      );
    } catch (error) {
      return request.post(`/getAppConfig.html`, {
        appId: params.appId
      });
    }
  }
  /**
   * 问政详情
   */
  getWzDetails(params: {
    appId: string;
    id: string;
    sessionId: string;
    token: string;
  }): Promise<IWzInfoResponse> {
    return request.post(`/wz/details.html`, {
      appId: params.appId,
      id: params.id,
      sessionId: this.sessionId || params.sessionId,
      token: this.token || params.token
    });
  }

  /**
   * 问政打分
   */
  subWzScore(params: {
    appId: string;
    id: string;
    score: string;
  }): Promise<IResponse> {
    return request.post(`/wz/score.html`, {
      sessionId: this.sessionId,
      token: this.token,
      appId: params.appId,
      id: params.id,
      score: params.score
    });
  }

  /**
   * 静态化配置
   */
  async getAppInfoConfigList() {
    let res;
    try {
      const res1 = await request.get(
        process.env.VUE_APP_BASE_JSON +
          `/app/news/Config/global/appInfoConfigList.json`
      );
      res = {
        code: 0,
        data: res1
      };
    } catch (error) {
      res = await request.post("/getAppInfoAndConfigList.html");
    }
    return res;
  }

  /**
   * 静态化时, 短视频的浏览量、点赞量、评论量调用政务云接口：/info/v2/addViewCount.html?sourceId={id}&sourceType=41
   */
  addViewCountScreen(id: any, sourceType: string) {
    return request.post(
      `/info/v2/addViewCount.html?sourceId=${id}&sourceType=${sourceType}`
    );
  }

  /**
   * 巴南新闻视频列表
   */
  getNewsList(
    appId: string,
    newsTime?: string | number,
    token?: string | number
  ): Promise<any> {
    return request.post("/newsTime/getNewsData.html", {
      appId,
      token,
      newsTime
    });
  }
  /**
   * 巴南新闻视频列表
   */
  getMonthsList(
    appId: string,
    newsTime: string,
    token?: string | number,
    sessionId?: string | number
  ): Promise<any> {
    return request.post("/newsTime/getNewsDataByTime.html", {
      appId,
      token,
      newsTime,
      sessionId
    });
  }
  /**
   * 根据父亲id获取子栏目
   * parentId ：父栏目id
   * isReturnP ：是否需要返回父栏目，默认不返，传值就要返
   * isShow: 是否过滤不可见栏目
   */
  getColumns(
    appId: string,
    parentId: string,
    isShow: boolean,
    isReturnP?: string
  ): Promise<any> {
    return request.post("/parent/getColumns.html", {
      appId,
      parentId,
      isReturnP,
      isShow
    });
  }
  // 根据栏目id获取新闻列表
  getnewsList(param: object): Promise<any> {
    return request.post("/info/news.html", param);
  }
  // 南岸街镇分享信息
  getNananShareInfo(): Promise<any> {
    let createUrl = "";
    if (
      process.env.VUE_APP_ENV == "development" ||
      process.env.VUE_APP_ENV == "testing"
    ) {
      // shareHost = "http://10.2.14.204:8080/";
      createUrl =
        "https://imagecdn.cqliving.com/images/app_4/server/na_jz_test.json";
    } else if (process.env.VUE_APP_ENV == "pre-release") {
      createUrl =
        "https://imagecdn.cqliving.com/images/app_4/server/na_jz_ready.json";
    } else {
      createUrl =
        "https://imagecdn.cqliving.com/images/app_4/server/na_jz_prod.json";
    }
    return request.get(createUrl);
  }
  // 开州号详情
  getMediaDetail(mjid: string): Promise<IMediaDetailResponse> {
    return request.post("/kzmj/detail.html", {
      v: 1,
      appId: this.appId,
      mjid,
      sessionId: this.sessionId,
      token: this.token
    });
  }
  // 开州号文章列表
  getMediaList(
    mjid: string,
    lastId: string,
    lastSortNo?: string,
    lastOnlineTime?: string
  ): Promise<IMediaListResponse> {
    return request.post("/kzmj/detailInfos.html", {
      v: 1,
      appId: this.appId,
      sessionId: this.sessionId,
      token: this.token,
      mjid,
      lastId,
      lastSortNo,
      lastOnlineTime
    });
  }
}
export default RequestIndex;
